import React from 'react';
import { Bed, Wifi, Maximize, ArrowRight, Star } from 'lucide-react';
import { motion } from 'framer-motion';

const RoomCard = ({ room }) => {
  const { title, size, price, target, badge, image } = room;

  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      whileHover={{ y: -10 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      className="group relative"
    >
      {/* Soothing Floating Card */}
      <div className="relative bg-white/40 backdrop-blur-sm border border-white/60 p-4 rounded-[2.5rem] shadow-[0_20px_50px_rgba(0,0,0,0.03)] hover:shadow-[0_30px_60px_rgba(249,115,22,0.1)] transition-all duration-700 h-full">
        
        {/* Compact Image Container */}
        <div className="relative aspect-[16/11] overflow-hidden rounded-[2rem] mb-6">
          <motion.img 
            src={image} 
            alt={title} 
            className="w-full h-full object-cover transition-transform duration-[2s] group-hover:scale-110"
          />
          <div className="absolute inset-0 bg-orange-900/10 opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
          
          <div className="absolute top-4 left-4">
            <span className="bg-white/80 backdrop-blur-md text-orange-600 text-[9px] tracking-widest uppercase font-bold px-4 py-2 rounded-xl shadow-sm">
              {badge}
            </span>
          </div>
        </div>

        {/* Catchy & Soothing Info */}
        <div className="px-2 pb-2">
          <div className="flex items-center justify-between mb-3">
            <span className="text-orange-500 text-[9px] tracking-[0.4em] uppercase font-black">{target}</span>
            <div className="flex items-center gap-1 text-orange-600">
              <span className="text-[10px] uppercase tracking-widest font-bold opacity-50">From</span>
              <span className="text-xl font-serif">₹{price.toLocaleString()}</span>
            </div>
          </div>
          
          <h3 className="text-2xl md:text-3xl font-serif text-luxury-black mb-4 leading-tight group-hover:text-orange-600 transition-colors duration-500">
            {title}
          </h3>

          <div className="flex items-center gap-6 mb-8">
            <div className="flex items-center gap-2 text-gray-400">
              <Bed className="w-4 h-4 text-orange-400/50" />
              <span className="text-[10px] tracking-wide uppercase font-medium">King</span>
            </div>
            <div className="flex items-center gap-2 text-gray-400">
              <Maximize className="w-4 h-4 text-orange-400/50" />
              <span className="text-[10px] tracking-wide uppercase font-medium">{size}</span>
            </div>
          </div>

          <button 
            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            className="w-full bg-luxury-black text-white py-4 rounded-2xl text-[10px] tracking-[0.3em] uppercase font-bold hover:bg-orange-600 transition-all duration-500 flex items-center justify-center gap-2 group/btn"
          >
            Check Availability
            <ArrowRight className="w-4 h-4 group-hover/btn:translate-x-1 transition-transform" />
          </button>
        </div>
      </div>
      
      {/* Decorative soft glow behind card */}
      <div className="absolute -z-10 inset-0 bg-orange-500/5 blur-[60px] opacity-0 group-hover:opacity-100 transition-opacity duration-1000" />
    </motion.div>
  );
};

export default RoomCard;
